import React from 'react'
import Card from './Card';
export default function CollectionPage() {
    let selectedCollection = null;
    try {
        selectedCollection = JSON.parse(localStorage.getItem('selectedCollection'));
    } catch {
        selectedCollection = null;
    }
    const collectionTitle = selectedCollection?.title || 'Collection';
    const products = JSON.parse(localStorage.getItem('Products')) || [];
    const filteredProducts = products.filter(p =>
        p.collections?.includes(collectionTitle)
    );

    console.log(filteredProducts);
    console.log(products);
    console.log(typeof products);
    console.log(collectionTitle);
    return (
        <>
            <div className='imagebg'>
                <h1>{collectionTitle}</h1>

            </div>
            <div className="rela">
                <div className="pro">

                    {/* Additional collection details can be added here */}
                    {filteredProducts.map(product => (
                        <Card
                            key={product.id}
                            id={product.id}
                            title={product.title}
                            image={product.image}        // note: in your object it's 'image', not 'mainimg'
                            price={product.price}
                            colors={product.colors}
                            carousel={product.carousel}
                            initialColor={product.colors?.[0]?.hex}
                            size={product.sizes}
                            carouselLength={product.carousel?.length || 0}
                            reviews={product.reviews}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}